import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/tippspielLogo.svg";

export function TippspielCommunityIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
